import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import AdminInstructionForm from './AdminInstructionForm';

export default function AdminInstructionCreate(props) {
    const [fetched, setFetched] = useState(false);
    const [fetchedSections, setFetchedSections] = useState(false);
    const [defaultOrder, setDefaultOrder] = useState(0);
    const [sections, setSections] = useState(null);

    useEffect(() => {
        axios
            .get(props.fetchUrl)
            .then((response) => {
                setDefaultOrder(response.data.order);
                setSections(response.data.sections);
            })
            .catch((e) => {
                console.log(e.response);
            })
            .finally(() => {
                setFetched(true);
            });
    }, []);

    useEffect(() => {
        if (sections) {
            setFetchedSections(true);
        }
    }, [sections]);

    return (
        <div>
            {fetched && fetchedSections && (
                <AdminInstructionForm
                    uploadUrl={props.uploadUrl}
                    saveUrl={props.saveUrl}
                    section={''}
                    content={''}
                    order={defaultOrder || 0}
                    sections={sections}
                    redirectUrl={props.redirectUrl}
                />
            )}
        </div>
    );
}

if (document.getElementById('create-user-guide-admin')) {
    ReactDOM.render(
        <App>
            <AdminInstructionCreate fetchUrl={fetchUrl} saveUrl={saveUrl} uploadUrl={uploadUrl} redirectUrl={redirectUrl} />
        </App>,
        document.getElementById('create-user-guide-admin'),
    );
}
